import viewFromAgentId from './viewFromAgentId';
import viewAgentId from './viewAgentId';
import userAccessType from './userAccessType';
import userNagivationAccess from './userNavigationAccess';
import { combineReducers } from 'redux';

const allReducers = combineReducers({
    viewFromAgentId,
    viewAgentId,
    userAccessType,
    userNagivationAccess

});

export default allReducers;